export default {
  getquote: {
    title: "Restaurant Registration",
    full_name: "Full Name",
    company_name: "Company Name",
    select_country: "Select Country",
    select_city: "Select City",
    restaurant: "Restaurant",
    email: "Email",
    phone: "Phone Number",
    next: "Next",
  },
};